export function reuseOrCreateByRef<T>(
  refs: string[],
  existing: T[],
  refOf: (item: T) => string,
  create: (ref: string) => T
): T[] {
  return refs.map(ref => existing.find(item => refOf(item) === ref) ?? create(ref));
}
